import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Typography,
  Badge,
  useTheme
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ChatIcon from '@mui/icons-material/Chat';

import { useState,useEffect } from 'react';
import useApi from 'hooks/useApi';
import useSelection from 'hooks/useSelection';
import { isValidDateValue,formatDateWithTimezoneDisplay, formatDynamicScalar } from 'utils/dateFormat';
import {PermissionWrapper} from 'components/PermissionComponents'
import { PERMISSIONS } from 'contexts/PermissionContext';
import WarningModal from 'utils/warningModel/warningMdel';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import { parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const ListViewTransactions = ({ loading, transactionData ,onRefresh,team,reportingStatus}: { loading: boolean; transactionData: any; onRefresh: () => void,team:string,reportingStatus:any }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  
  // Warning Modal State
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [transactionToDelete, setTransactionToDelete] = useState<any>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  
  const toggleExpand = (key: string) => {
    setExpandedRows(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

   function toSentenceCase(input: string): string {
      const quotedMap: Record<number, string> = {};
      let idx = 0;

      // Step 1: Replace "quoted" text with lowercase placeholders
      //         Store the UPPERCASED version in quotedMap
      const withPlaceholders = input.replace(
        /"([^"]*)"/g,
        (_: string, inner: string): string => {
          const key = `__q${idx}__`;
          quotedMap[idx] = inner.toUpperCase();
          idx++;
          return key;
        }
      );

      // Step 2: Lowercase everything, then capitalize only the first char
      const sentenceCased = withPlaceholders
        .toLowerCase()
        .replace(/^\w/, (c: string): string => c.toUpperCase());

      // Step 3: Restore placeholders with their UPPERCASE values
      return sentenceCased.replace(
        /__q(\d+)__/g,
        (_: string, i: string): string => quotedMap[Number(i)]
      );
    }

     const formatResourceValue = (value: any): string => {
    if (Array.isArray(value) && value.length > 0) {
      const firstResource = value[0];
      if (typeof firstResource === 'object' && firstResource !== null) {
        // Check if it's a resource object with fields
        if (firstResource.fields && Object.keys(firstResource.fields).length > 0) {
          // Display first 2 resources
          const resourcesToShow = value.slice(0, 2);
          const resourceStrings = resourcesToShow.map((resource: any) => {
            if (resource.fields && Object.keys(resource.fields).length > 0) {
              // Show first 2 fields from each resource
              return Object.values(resource.fields)
                .slice(0, 2)
                .map(v => String(v))
                .join(', ');
            }
            return 'Resource';
          });
          
          const result = resourceStrings.join(' | ');
          return value.length > 2 ? result + ' ...' : result;
        }
        // If no fields, try to display any meaningful property
        return 'Resource Data';
      }
    }
    return String(value);
  };
  const [eventTypes, setEventTypes] = useState<any>(['IMAGE', 'VIDEO', 'SESSION', 'SIGN', 'LOCATION']);
  
  const [eventStatus, setEventStatus] = useState<any>([
    'UPLOADED',
    'CALLING',
    'RECEIVED',
    'IN_PROGRESS',
    'MISSED_CALL',
    'MANUAL_DISCONNECT',
    'COMPLETED'
  ]);
  const [hoveredTxnIdx, setHoveredTxnIdx] = useState<number | null>(null);
  const [teamOptions, setTeamOptionss] = useState<any[]>([]);
  const { getTeamByClient, deleteTransaction, showToast } = useApi();
  const { setSelectedClient, selectedTeam, setSelectedTeam, selectedClient } = useSelection();
  const [hoveredFiles, setHoveredFiles] = useState<any[]>([]);
  const navigate = useNavigate();
  console.log("reportingStatus",reportingStatus)
  const getFileIcon = (mimeType: string) => {
  if (mimeType?.includes('pdf')) return '📄';
  if (mimeType?.includes('image')) return '🖼️';
  if (mimeType?.includes('excel') || mimeType?.includes('spreadsheet') || mimeType?.includes('xls')) return '📊';
  if (mimeType?.includes('word') || mimeType?.includes('document')) return '📝';
  if (mimeType?.includes('video')) return '🎥';
  return '📎';
};
// console.log("statusMap",keyStatusMap)

//   if (
//     typeof value === 'string' &&
//     /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/.test(value)
//   ) {
//     const date = new Date(value);
//     if (!isNaN(date.getTime())) {
//       return date.toLocaleDateString(undefined, {
//         year: 'numeric',
//         month: 'short', // e.g. "Aug"
//         day: '2-digit'
//       });
//     }
//   }
//   return value;
// }
 const fetchKeyStatuses = async (teamUid: string) => {
  try {
    // const res = await getNodeStatus(teamUid);
    const statusMap: Record<string, string> = {};
    console.log("reportingStatus",reportingStatus)
    reportingStatus.forEach((status: any) => {
      statusMap[status._id] = status.name;
    });
    console.log("statusMap",statusMap)
    
  } catch (error) {
    console.error('Failed to fetch key statuses:', error);
  }
};

  useEffect(() => {
    if (selectedTeam) {
      fetchKeyStatuses(selectedTeam);
    }
  }, [selectedTeam]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = 'simple-popover' ;
  

  
  // Fetch teams when client changes

  function formatToLocalTime(value: string) {
    console.log(value,'value data');
    return formatDateWithTimezoneDisplay(value); // No time, but includes timezone if available
  }


  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setEventTypes((prev: any[]) => (checked ? [...prev, value] : prev.filter((item: string) => item !== value)));
  };

  const handleEventStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setEventStatus((prev: any[]) => (checked ? [...prev, value] : prev.filter((item: string) => item !== value)));
  };

  const getBorderColor = (status: string | null | undefined): string => {
    if (!status || typeof status !== 'string') {
      return 'secondary.dark'; 
    }

    switch (status.toLowerCase()) {
      case 'cancelled':
      case 'failed':
        return '#f44336'; // Red
      case 'delivered':
      case 'completed':
        return '#4caf50'; // Green
      case 'in-transit':
      case 'in_progress':
        return '#ff9800'; // Orange
      case 'pending':
      case 'uploaded':
        return '#2196f3'; // Blue
      default:
        return '#9c27b0'; // Purple
    }
  };

  // Driver Rest / Stop / Swap state → card chip.
  const driverStateMeta = (state: string | null | undefined): { label: string; color: string } | null => {
    switch ((state || '').toUpperCase()) {
      case 'RESTING':
        return { label: 'Resting', color: '#ff9800' };
      case 'STOPPED':
        return { label: 'Stopped', color: '#d32f2f' };
      case 'SWAPPED':
        return { label: 'Swapped', color: '#757575' };
      default:
        return null;
    }
  };

  const handleResetFilter = () => {
    setEventTypes(['IMAGE', 'VIDEO', 'SESSION', 'SIGN', 'LOCATION']);
    setEventStatus(['UPLOADED', 'CALLING', 'RECEIVED', 'IN_PROGRESS', 'MISSED_CALL', 'MANUAL_DISCONNECT', 'COMPLETED']);
  };

  const handleFilterClientChange = async (clientId: string) => {
    setSelectedClient(clientId);
    if (clientId) {
      try {
        const res = await getTeamByClient(clientId);
        setTeamOptionss(res?.data || []);
      } catch {
        setTeamOptionss([]);
      }
    } else {
      setTeamOptionss([]);
      setSelectedTeam('');
    }
  };

  const handleDelete = (txn: any) => {
    setTransactionToDelete(txn);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!transactionToDelete) return;
    
    setDeleteLoading(true);
    try {
      await deleteTransaction(transactionToDelete.key);
      showToast('Transaction deleted successfully', 'success');
      
      // Call the refresh function from parent
      if (onRefresh) {
        onRefresh();
      }
      
      // Close modal and reset state
      setDeleteModalOpen(false);
      setTransactionToDelete(null);
    } catch (error) {
      showToast('Failed to delete transaction', 'error');
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setTransactionToDelete(null);
  };  // Search handler


  const renderTransactionContent = () => {
  // No client or team selected
  if (!selectedClient || !selectedTeam) {
    return (
      <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        Please Select Team
      </Box>
    );
  }

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          bgcolor: 'grey.50',
          borderRadius: 1.2,
          border: '2px dashed',
          borderColor: 'grey.300',
          minHeight: 200
        }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
          Loading transactions...
        </Typography>
      </Box>
    );
  }

  // No transactions found
  if (!transactionData?.rows || transactionData.rows.length === 0) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          bgcolor: 'grey.50',
          borderRadius: 1.2,
          border: '2px dashed',
          borderColor: 'grey.300',
          minHeight: 200
        }}
      >
        <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          No Transaction Data Available
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
          Try adjusting your filters or date range
        </Typography>
      </Box>
    );
  }

  // Render transactions
  return transactionData?.rows?.map((txn: any, idx: number) => {
    console.log(txn, "txntxn....");
    // Determine which fields to display
    const displayFields =
        txn?.additionalFields && typeof txn.additionalFields === 'object'
          ? Object.keys(txn.additionalFields)
          : [];
  
    return (
    <>
      <Box
        key={idx}
        onClick={() =>
          navigate(`/transactions/details/${txn?.team?.uid}/${txn?.uid}/${txn?.key}`)
        }
        sx={{
          position: 'relative', // Add this
          border: '1px solid',
          borderColor: getBorderColor(txn.status),
          borderRadius: 1.2,
          p: 1,
          mb: 1,
          bgcolor: 'white',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            borderColor: 'secondary.main',
          },
        }}
      >
        <Grid container spacing={1} alignItems="flex-start">
          {/* Dynamic Fields */}
          {displayFields.map((field: any, i: number) => {
            const value: any = (txn?.additionalFields as Record<string, unknown>)?.[field];
            
            return (
              <Grid item xs={6} md={2} key={i}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      color: 'text.secondary',
                      textTransform: 'uppercase',
                    }}
                  >
                    {toSentenceCase(field)}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      color: 'text.primary',
                      wordBreak: 'break-word',
                    }}
                  >
                    {value !== undefined && value !== null && value !== ""
                      ? Array.isArray(value)
                      ? (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && 'fields' in value[0])
                      ? formatResourceValue(value)
                      : value.map(v => formatDynamicScalar(v)).join(", ")
                      : isValidDateValue(value)
                      ? formatToLocalTime(value)
                      : String(value)
                      : "-"}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
          
          {(txn?.key && (txn?.team?.transactionFieldSelect?.length === 0) || !txn?.team?.transactionFieldSelect) && (
          <Grid item xs={6} md={2}>
            <Box>
              <Typography
                variant="caption"
                sx={{ fontSize: "0.65rem", fontWeight: 600, color: "text.secondary" }}
              >
                {txn?.team?.settings?.transactionLabel || "Auth Key"}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "0.75rem", fontWeight: 500, color: "text.primary" }}
                >
                  {txn?.key || "-"}
                </Typography>
                {Number(txn?.alertCount) > 0 && (
                  <Box
                    title={`${txn.alertCount} alert${txn.alertCount === 1 ? '' : 's'}`}
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: 18,
                      height: 18,
                      px: 0.6,
                      fontSize: '0.65rem',
                      fontWeight: 700,
                      color: '#fff',
                      bgcolor: 'error.main',
                      borderRadius: '9px',
                      lineHeight: 1,
                    }}
                  >
                    {txn.alertCount > 99 ? '99+' : txn.alertCount}
                  </Box>
                )}
                {driverStateMeta(txn?.driverState) && (
                  <Box
                    title={`Driver ${driverStateMeta(txn?.driverState)!.label}`}
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      height: 18,
                      px: 0.7,
                      fontSize: '0.6rem',
                      fontWeight: 700,
                      color: '#fff',
                      bgcolor: driverStateMeta(txn?.driverState)!.color,
                      borderRadius: '9px',
                      lineHeight: 1,
                      textTransform: 'uppercase',
                      letterSpacing: 0.3,
                    }}
                  >
                    {driverStateMeta(txn?.driverState)!.label}
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
        )}
          {/* Step Status */}
          {txn?.team?.displayStepStatus && (
            <Grid item xs={6} md={2}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    textTransform: 'uppercase',
                  }}
                >
                Activity Status
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                  {txn?.displayStatus || '-'}
                </Typography>
              </Box>
            </Grid>
          )}

          {/* Reporting Status */}
          {txn?.team?.reportingStatus && txn?.keyStatus && (
            <Grid item xs={6} md={2}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    textTransform: 'uppercase',
                  }}
                >
                  Status
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                  {reportingStatus?.[txn?.keyStatus] || '-'}
                </Typography>
              </Box>
            </Grid>
          )}

          {/* Process */}
          {txn?.team?.process && (
            <Grid item xs={6} md={2}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    textTransform: 'uppercase',
                  }}
                >
                  Process
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                  {txn?.team?.name || '-'}
                </Typography>
              </Box>
        
            </Grid>
          )}
                   {/* File and Delete Icons */}
        
        </Grid>
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          {/* File Icon - Show if file_Attachment is true */}          
          {txn?.file_Attachment && (
            <Box
              onMouseEnter={(e) => {
                  setHoveredFiles(txn?.file_attachmet_list || []);
                  setHoveredTxnIdx(idx); // <-- add this
                }}
                onMouseLeave={() => {
                  setHoveredFiles([]);
                  setHoveredTxnIdx(null); // <-- add this
                }}
              sx={{
                color: '#000000',
                bgcolor: 'background.paper',
                padding: 0.2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                '& svg': { width: '20px', height: '20px' }
              }}
            >
              <AttachFileIcon />
            </Box>
          )}

          {/* File Hover Box */}
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 48,
              bgcolor: 'background.paper',
              borderRadius: 1,
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              p: '5px',
              minWidth: 280,
              maxWidth: 360,
              display: hoveredTxnIdx === idx ? 'flex' : 'none',
              flexDirection: 'column',
              gap: 0.8,
              zIndex: 1300,
              pointerEvents: 'none',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
              {hoveredFiles.map((file: any, i: number) => (
                <Box
                  key={file._id || i}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: '2px',
                    borderRadius: 1,
                    bgcolor: 'grey.50',
                    border: '1px solid',
                    borderColor: 'grey.200',
                  }}
                >
                  <Typography sx={{ fontSize: '1rem', lineHeight: 1 }}>
                    {getFileIcon(file.mime_type)}
                  </Typography>
                  <Box sx={{ overflow: 'hidden', flex: 1 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                      }}
                    >
                      {file.file_name}
                    </Typography>
                   </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Unread Chat Count Badge */}
          {txn?.unreadChatCount > 0 && (
            <Badge
              badgeContent={txn.unreadChatCount}
              color="error"
              max={99}
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.65rem',
                  height: '18px',
                  minWidth: '18px',
                },
              }}
            >
              <Box
                sx={{
                  color: '#1976d2',
                  bgcolor: 'background.paper',
                  padding: 0.2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '& svg': {
                    width: '20px',
                    height: '20px',
                  }
                }}
              >
                <ChatIcon />
              </Box>
            </Badge>
          )}
          
          {/* AI Detection Badge */}
          {txn?.hasDetection && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.4,
                bgcolor: 'rgba(76, 175, 80, 0.1)',
                border: '1px solid rgba(76, 175, 80, 0.3)',
                borderRadius: 0.75,
                px: 0.75,
                py: 0.2,
              }}
            >
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#4caf50' }} />
              <Typography sx={{ fontSize: '0.6rem', fontWeight: 600, color: '#2e7d32' }}>AI</Typography>
            </Box>
          )}

          {/* Delete Icon */}
          <PermissionWrapper permission={PERMISSIONS.DELETE_TRANSACTIONS} disableInsteadOfHide>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(txn);
              }}
              sx={{
                color: 'error.main',
                bgcolor: 'background.paper',
                '&:hover': {
                  bgcolor: 'error.lighter',
                }
              }}
              size="large"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </PermissionWrapper>
        </Box>
        {Array.isArray(txn?.children) && txn?.children?.length > 0 && (
          <Box
            sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', }}
            onClick={(e) => { e.stopPropagation();  toggleExpand(txn.key); }}
          >
            {expandedRows[txn.key] ? (
              <KeyboardArrowDownIcon fontSize="small" />
            ) : (
              <KeyboardArrowRightIcon fontSize="small" />
            )}
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {/* {expandedRows[txn.key] ? 'Sub Transactions' : 'Sub Transactions'} */}
              Sub Transactions
            </Typography>
          </Box>
        )}
          {expandedRows[txn.key] &&
            Array.isArray(txn.children) &&
            txn.children.length > 0 && (
              <Box sx={{ mt: 1, ml: 0}}>
                {txn.children.map((child: any, cidx: number) => (
                  <Box
                    key={cidx}
                    sx={{
                      borderRadius: 1,
                      border: `1px solid ${theme.palette.secondary.main}`,
                      p: 0.75,
                      mb: 0.75,
                      cursor: 'pointer'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/transactions/details/${child?.team?.uid}/${child?.uid}/${child?.key}`);
                    }}
                  >
                    <Grid container spacing={1}>
                      
                      {/* Auth Key */}
                      <Grid item xs={6} md={2}>
                        <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase' }}>
                          Auth Key
                        </Typography>
                        <Typography variant="body2"> {child?.key || '-'} </Typography>
                      </Grid>

                      {/* Activity Status */}
                      {child?.displayStatus && (
                        <Grid item xs={6} md={2}>
                          <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase' }}>
                            Activity Status
                          </Typography>
                          <Typography variant="body2">{child?.displayStatus} </Typography>
                        </Grid>
                      )}

                      {/* Reporting Status */}
                      {child?.keyStatus && (
                        <Grid item xs={6} md={2}>
                          <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase' }}>
                            Status
                          </Typography>
                          <Typography variant="body2"> {reportingStatus?.[child?.keyStatus] || '-'} </Typography>
                        </Grid>
                      )}

                      {/* Process */}
                      <Grid item xs={6} md={2}>
                        <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase' }}>
                          Process
                        </Typography>
                        <Typography variant="body2"> {child?.team?.name || '-'} </Typography>
                      </Grid>

                    </Grid>
                  </Box>
                ))}
              </Box>
            )}
        </Box>
      </>
    );
  });
};

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>

        {/* Header Section */}
       <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        pr: 1,
        '&::-webkit-scrollbar': {
          width: '8px'
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '10px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8'
        }
      }}
    >
      {renderTransactionContent()}
    </Box>
      

     

      {/* Enhanced Filter Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
            maxWidth: 600,
            width: { xs: '95vw', sm: 'auto' }
          }
        }}
      >
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 3,
              fontWeight: 600,
              color: 'text.primary'
            }}
          >
            Filter Transactions
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              mb: 3
            }}
          >
            <FormControl fullWidth size="small">
              <InputLabel>Clients</InputLabel>
              <Select
                value={selectedClient || ''}
                label="Clients"
                onChange={(e) => handleFilterClientChange(e.target.value)}
                sx={{
                  borderRadius: 1.5,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'grey.300'
                  }
                }}
              >
                {/* {clientOptions?.map((client: any) => (
                  <MenuItem key={client.uid} value={client.uid}>
                    {client.name}
                  </MenuItem>
                ))} */}
              </Select>
            </FormControl>

            <FormControl fullWidth size="small">
              <InputLabel>Teams</InputLabel>
              <Select
                multiple
                value={Array.isArray(selectedTeam) ? selectedTeam : []}
                label="Teams"
                onChange={(e: any) => setSelectedTeam(e.target.value)}
                sx={{
                  borderRadius: 1.5,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'grey.300'
                  }
                }}
              >
                {teamOptions?.map((team: any) => (
                  <MenuItem key={team.uid} value={team.uid}>
                    {team.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Event Types Filter */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'text.primary'
              }}
            >
              Include Types
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                gap: 1
              }}
            >
              {[
                { value: 'IMAGE', label: 'Images' },
                { value: 'VIDEO', label: 'Videos' },
                { value: 'SESSION', label: 'Sessions' },
                { value: 'SIGN', label: 'Signs' },
                { value: 'LOCATION', label: 'Locations' }
              ].map((type) => (
                <FormControlLabel
                  key={type.value}
                  control={
                    <Checkbox
                      value={type.value}
                      checked={eventTypes.includes(type.value)}
                      onChange={handleCheckboxChange}
                      sx={{
                        '&.Mui-checked': {
                          color: 'primary.main'
                        }
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {type.label}
                    </Typography>
                  }
                />
              ))}
            </Box>
          </Box>

          {/* Event Status Filter */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'text.primary'
              }}
            >
              Include Status
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                gap: 1
              }}
            >
              {[
                { value: 'UPLOADED', label: 'Uploading' },
                { value: 'CALLING', label: 'Calling' },
                { value: 'RECEIVED', label: 'Received' },
                { value: 'IN_PROGRESS', label: 'In Progress' },
                { value: 'MISSED_CALL', label: 'Missed Calls' },
                { value: 'MANUAL_DISCONNECT', label: 'Manual Disconnect' },
                { value: 'COMPLETED', label: 'Completed' }
              ].map((status) => (
                <FormControlLabel
                  key={status.value}
                  control={
                    <Checkbox
                      value={status.value}
                      checked={eventStatus.includes(status.value)}
                      onChange={handleEventStatusChange}
                      sx={{
                        '&.Mui-checked': {
                          color: 'primary.main'
                        }
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {status.label}
                    </Typography>
                  }
                />
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5,
              borderTop: '1px solid',
              borderColor: 'grey.200',
              pt: 2.5,
              mt: 2.5
            }}
          >
            <Button
              variant="text"
              
              onClick={handleResetFilter}
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                color:"text.main"
              }}
            >
              Reset Filter
            </Button>
            <Button
              variant="contained"
              
            
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 1.5,
                px: 3,
                color:"text.main",
                bgcolor:"secondary.dark"
              }}
            >
              Apply Filter
            </Button>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderRadius: 1.5
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Delete Confirmation Modal */}
      <WarningModal
        open={deleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title={`Delete Transaction   : ${transactionToDelete?.key || ''}`}
        type="delete"
        confirmText="Delete"
        cancelText="Cancel"
        loading={deleteLoading}
        message={`Are you sure you want to delete this transaction? "${transactionToDelete?.key || ''}"`}
       
        subHeadings={[
          "Once deleted, this transaction will be permanently removed from the system.",
          "All associated data and history will be lost.",
          `Transaction Key: ${transactionToDelete?.key || 'N/A'}`
        ]}
        maxWidth="sm"
        fullWidth={false}
      />
    </Box>
  );
};

export default ListViewTransactions;
